import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';

var TabContentBase = function TabContentBase(_a) {
  var id = _a.id,
      activeKey = _a.activeKey,
      ariaLabel = _a['aria-label'],
      child = _a.child,
      children = _a.children,
      className = _a.className,
      eventKey = _a.eventKey,
      innerRef = _a.innerRef,
      props = __rest(_a, ["id", "activeKey", 'aria-label', "child", "children", "className", "eventKey", "innerRef"]);

  if (children || child) {
    var labelledBy;

    if (ariaLabel) {
      labelledBy = null;
    } else {
      labelledBy = children ? "pf-tab-".concat(eventKey, "-").concat(id) : "pf-tab-".concat(child.props.eventKey, "-").concat(id);
    }

    return React.createElement("section", Object.assign({
      ref: innerRef,
      hidden: children ? null : child.props.eventKey !== activeKey,
      className: children ? css('pf-c-tab-content', className) : css('pf-c-tab-content', child.props.className),
      id: children ? id : "pf-tab-section-".concat(child.props.eventKey, "-").concat(id),
      "aria-label": ariaLabel,
      "aria-labelledby": labelledBy,
      role: "tabpanel",
      tabIndex: 0
    }, props), children || child.props.children);
  }

  return null;
};

export var TabContent = React.forwardRef(function (props, ref) {
  return React.createElement(TabContentBase, Object.assign({}, props, {
    innerRef: ref
  }));
});